module.exports = __webpack_public_path__ + "static/media/spoon.a6d6485d.png";